import { allValidString } from "../../utility";
import { NotificationService } from "../notification/notification.service";

export const configValidator = ({
  defaultReqObj = 'reqObject',
  messageDelay = 2000
} = {}) => {
  return {
    mounted: function () {
      const validation = allValidString (this[defaultReqObj]);

      if (!validation.valid) {
        NotificationService.showNotification({
          text: `${validation.invalid.join(', ')} - not valid`,
          timeout: messageDelay,
        }).then(res => {
          this.$emit('cancelled', true);
        });
      }
    }
  }
}